(function(){
  if (window.__isxUI) return; window.__isxUI = true;

  /* Fade up on scroll: every block inside an iSpice section rises in as it enters the screen,
     neighbours a beat apart. The attribute is removed afterwards so each block's own hover and
     animation transforms work again. Sections can opt out with data-no-reveal. */
  function reveal(){
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && Shopify.designMode) return;
    var SEL = '.isx-wrap > *, .isx-head > *, .isx-rail > *, [class*="__list"] > li, [class*="__grid"] > *, [class*="__tiles"] > *';
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        el.classList.add('is-rv');
        var d = parseInt(el.style.getPropertyValue('--rv-d') || 0, 10);
        setTimeout(function(){ el.removeAttribute('data-rv'); el.classList.remove('is-rv'); el.style.removeProperty('--rv-d'); }, 950 + d);
      });
    }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    document.querySelectorAll('section.isx:not([data-no-reveal])').forEach(function(sec){
      var seen = [];
      sec.querySelectorAll(SEL).forEach(function(el){
        if (seen.some(function(p){ return p.contains(el); }) && !el.matches('.isx-rail > *, [class*="__list"] > li, [class*="__grid"] > *, [class*="__tiles"] > *')) return;
        if (el.closest('[data-no-reveal]') || el.matches('script,style,template')) return;
        seen.push(el);
      });
      seen.forEach(function(el){
        var sib = Array.prototype.indexOf.call(el.parentNode.children, el);
        el.setAttribute('data-rv', '');
        el.style.setProperty('--rv-d', Math.min(sib, 6) * 90 + 'ms');
        io.observe(el);
      });
    });
  }
  /* Pause CSS loops (floating capsule, recipe blobs) while their section is off screen. */
  function offscreen(){
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ e.target.classList.toggle('isx-off', !e.isIntersecting); });
    }, { rootMargin: '200px 0px' });
    document.querySelectorAll('section.isx').forEach(function(s){ io.observe(s); });
  }
  function boot(){ reveal(); offscreen(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  function refreshCart(){
    try{
      var c = window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart;
      if (c && c.updateView) c.updateView();
      if (c && c.showDrawer) setTimeout(function(){ c.showDrawer(); }, 350);
    }catch(e){ console.warn('iSpice: cart refresh failed', e); }
  }
  document.addEventListener('click', function(ev){
    var b = ev.target.closest('[data-isx-add]');
    if (!b) return;
    ev.preventDefault();
    if (b.disabled) return;
    var ids = String(b.getAttribute('data-isx-add')).split(',').filter(Boolean);
    var items = ids.map(function(id){ return { id: Number(id), quantity: 1 }; });
    var label = b.innerHTML;
    b.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r){
      if (!r.ok) return r.json().then(function(j){ throw new Error(j.description || j.message || r.status); });
      return r.json();
    }).then(function(){
      b.classList.add('is-done');
      b.innerHTML = b.getAttribute('data-isx-done') || 'Added';
      refreshCart();
      setTimeout(function(){ b.classList.remove('is-done'); b.innerHTML = label; b.disabled = false; }, 2200);
    }).catch(function(err){
      console.warn('iSpice: add to cart failed', err);
      b.innerHTML = 'Try again';
      setTimeout(function(){ b.innerHTML = label; b.disabled = false; }, 2200);
    });
  });

  /* ---------- Quick view ----------
     Any element with data-isx-qv="<product handle>" opens a pop-up with the product's photos,
     options, quantity and add to cart, read live from /products/<handle>.js. Ctrl/cmd-click on
     a link still opens the product page. One <dialog> is built lazily and reused. */
  var qv = null, qvLast = null, qvCache = {};
  function esc(t){ return String(t == null ? '' : t).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function money(cents){
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function img(url, w){ if (!url) return ''; url = url.indexOf('//') === 0 ? 'https:' + url : url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  /* Same naming rule as snippets/ispice-card.liquid: titles are "iSpice | Name | Size | ...";
     for packs ("24 Pack of Spice and Herbs | Silk Road") the set's name is segment 3. */
  function names(t){
    var p = String(t).split(' | ').map(function(x){ return x.trim(); });
    var name = p.length > 1 ? p[1] : String(t), size = p.length > 2 ? p[2] : '';
    if (name.indexOf('Pack of') > -1 && size) { var pack = name.split(' of ')[0]; name = size; size = pack; }
    return { name: name, size: size };
  }
  function niceName(t){ return names(t).name; }
  function packName(t){ return names(t).size; }
  function build(){
    qv = document.createElement('dialog');
    qv.className = 'isx isx-qv';
    qv.setAttribute('aria-labelledby', 'isx-qv-title');
    qv.innerHTML = '<button type="button" class="isx-qv__x" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><div class="isx-qv__body"></div>';
    document.body.appendChild(qv);
    qv.querySelector('.isx-qv__x').addEventListener('click', close);
    qv.addEventListener('click', function(e){ if (e.target === qv) close(); });   // backdrop
    qv.addEventListener('close', function(){
      document.documentElement.classList.remove('isx-qv-open');
      if (qvLast && qvLast.focus) qvLast.focus({ preventScroll: true });
    });
  }
  function close(){ if (qv && qv.open) qv.close(); }
  function render(p){
    var body = qv.querySelector('.isx-qv__body');
    var opts = (p.options || []).map(function(o){ return typeof o === 'string' ? o : o.name; });
    var single = p.variants.length === 1 && (opts.length === 0 || (opts.length === 1 && opts[0] === 'Title'));
    var v = p.variants.filter(function(x){ return x.available; })[0] || p.variants[0];
    var imgs = (p.images || []).slice(0, 8);
    var text = '';
    if (p.description) { var d = new DOMParser().parseFromString(p.description, 'text/html'); text = (d.body.textContent || '').replace(/\s+/g, ' ').trim(); }
    if (text.length > 320) text = text.slice(0, 317).replace(/\s+\S*$/, '') + '...';
    var html = '<div class="isx-qv__grid"><div class="isx-qv__gallery">'
      + '<div class="isx-qv__main"><img src="' + esc(img(imgs[0] || p.featured_image, 900)) + '" alt="' + esc(niceName(p.title)) + '"></div>';
    if (imgs.length > 1) {
      html += '<div class="isx-qv__thumbs">' + imgs.map(function(u, i){
        return '<button type="button" class="isx-qv__thumb' + (i === 0 ? ' is-on' : '') + '" data-src="' + esc(img(u, 900)) + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(img(u, 160)) + '" alt="" loading="lazy"></button>';
      }).join('') + '</div>';
    }
    html += '</div><div class="isx-qv__info">';
    var pack = packName(p.title);
    if (pack) html += '<p class="isx-qv__pack">' + esc(pack) + '</p>';
    html += '<h2 class="isx-qv__title" id="isx-qv-title">' + esc(niceName(p.title)) + '</h2>'
      + '<p class="isx-qv__price" aria-live="polite"></p>';
    if (!single) {
      opts.forEach(function(name, oi){
        var vals = [];
        p.variants.forEach(function(x){ var val = x.options[oi]; if (vals.indexOf(val) < 0) vals.push(val); });
        html += '<fieldset class="isx-qv__opt"><legend>' + esc(name) + '</legend><div>' + vals.map(function(val){
          return '<button type="button" class="isx-qv__val" data-oi="' + oi + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        }).join('') + '</div></fieldset>';
      });
    }
    html += '<div class="isx-qv__buy"><div class="isx-qv__qty" role="group" aria-label="Quantity"><button type="button" data-q="-1" aria-label="Less">&minus;</button><input type="number" min="1" max="99" value="1" aria-label="Quantity"><button type="button" data-q="1" aria-label="More">+</button></div>'
      + '<button type="button" class="isx-btn isx-qv__add"></button></div>'
      + '<p class="isx-qv__msg" role="status"></p>';
    if (text) html += '<p class="isx-qv__desc">' + esc(text) + '</p>';
    html += '<a class="isx-link isx-qv__more" href="' + esc(p.url || ('/products/' + p.handle)) + '">View full details</a></div></div>';
    body.innerHTML = html;

    var sel = v.options ? v.options.slice() : [];
    var add = body.querySelector('.isx-qv__add'), qty = body.querySelector('.isx-qv__qty input');
    var price = body.querySelector('.isx-qv__price'), msg = body.querySelector('.isx-qv__msg');
    function current(){ return single ? p.variants[0] : p.variants.filter(function(x){ return x.options.every(function(o, i){ return o === sel[i]; }); })[0]; }
    function update(){
      v = current();
      body.querySelectorAll('.isx-qv__val').forEach(function(b){
        var oi = +b.dataset.oi, on = sel[oi] === b.dataset.val;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
        // grey out values that make no available variant with the other current choices
        var ok = p.variants.some(function(x){ return x.available && x.options[oi] === b.dataset.val && x.options.every(function(o, i){ return i === oi || o === sel[i]; }); });
        b.classList.toggle('is-out', !ok);
      });
      if (!v) { price.textContent = ''; add.disabled = true; add.textContent = 'Unavailable'; return; }
      price.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s> <span class="isx-qv__save">Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%</span>' : '');
      add.disabled = !v.available;
      add.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_image && v.featured_image.src) swap(img(v.featured_image.src, 900));
    }
    function swap(src){ var m = body.querySelector('.isx-qv__main img'); if (m && src) m.src = src; }
    body.querySelectorAll('.isx-qv__thumb').forEach(function(t){
      t.addEventListener('click', function(){
        body.querySelectorAll('.isx-qv__thumb').forEach(function(x){ x.classList.toggle('is-on', x === t); });
        swap(t.dataset.src);
      });
    });
    body.querySelectorAll('.isx-qv__val').forEach(function(b){ b.addEventListener('click', function(){ sel[+b.dataset.oi] = b.dataset.val; msg.textContent = ''; update(); }); });
    body.querySelectorAll('.isx-qv__qty button').forEach(function(b){
      b.addEventListener('click', function(){ qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + +b.dataset.q)); });
    });
    add.addEventListener('click', function(){
      if (!v || !v.available || add.disabled) return;
      var n = Math.min(99, Math.max(1, parseInt(qty.value, 10) || 1));
      add.disabled = true; add.textContent = 'Adding...'; msg.textContent = '';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: n }] })
      }).then(function(r){
        if (!r.ok) return r.json().then(function(j){ throw new Error(j.description || j.message || r.status); });
        return r.json();
      }).then(function(){
        add.textContent = 'Added ✓'; add.classList.add('is-done');
        setTimeout(function(){ close(); refreshCart(); }, 700);
      }).catch(function(err){
        console.warn('iSpice: quick view add to cart failed', err);
        msg.textContent = String(err.message || 'Could not add to cart. Please try again.');
        add.disabled = false; add.textContent = 'Add to cart';
      });
    });
    update();
  }
  function openQV(handle){
    if (!handle) return;
    if (!qv) build();
    var body = qv.querySelector('.isx-qv__body');
    body.innerHTML = '<div class="isx-qv__loading" role="status"><span></span>Loading...</div>';
    document.documentElement.classList.add('isx-qv-open');
    if (!qv.open) qv.showModal();
    var get = qvCache[handle] || (qvCache[handle] = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }));
    get.then(render).catch(function(err){
      delete qvCache[handle];
      console.warn('iSpice: quick view could not load ' + handle, err);
      body.innerHTML = '<div class="isx-qv__loading">Sorry, this product could not be loaded. <a class="isx-link" href="/products/' + esc(handle) + '">Open the product page</a></div>';
    });
  }
  window.isxQuickView = openQV;
  document.addEventListener('click', function(ev){
    var t = ev.target.closest && ev.target.closest('[data-isx-qv]');
    if (!t) return;
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button === 1) return;   // new tab: let the link work
    if (!window.HTMLDialogElement) return;                                    // very old browser: follow the link
    ev.preventDefault();
    qvLast = t;
    openQV(t.getAttribute('data-isx-qv'));
  });
})();

/* Phones: a pager under every carousel that still scrolls sideways: arrows, a progress bar and "2 / 6" (2026-10-01) */
(function(){
  var SEL = '.isx .isx-rail:not(.isx-rv__tiles), .isx .isx-rc__list, .isx .isx-kr__grid';
  var mq = window.matchMedia ? matchMedia('(max-width: 749px)') : null;
  var ARROW = function(d){ return '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="' + (d < 0 ? 'M10 3L5 8l5 5' : 'M6 3l5 5-5 5') + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };
  function items(el){ return Array.prototype.filter.call(el.children, function(c){ return c.offsetWidth > 0; }); }
  function update(el){
    var p = el._isxPager; if (!p) return;
    var sw = el.scrollWidth, cw = el.clientWidth, sl = el.scrollLeft;
    if (!mq || !mq.matches || sw <= cw + 4) { p.hidden = true; return; }
    p.hidden = false;
    p._thumb.style.width = (cw / sw * 100) + '%';
    p._thumb.style.left = (sl / sw * 100) + '%';
    var list = items(el), n = list.length;
    if (n > 1 && n <= 16) {
      var box = el.getBoundingClientRect(), i = 0;
      if (sl + cw >= sw - 4) i = n - 1;
      else for (var k = 0; k < n; k++) { if (list[k].getBoundingClientRect().right > box.left + 24) { i = k; break; } }
      p._n.textContent = (i + 1) + ' / ' + n;
    } else p._n.textContent = '';
    p._prev.disabled = sl <= 2;
    p._next.disabled = sl + cw >= sw - 2;
  }
  function step(el){
    var list = items(el);
    if (list.length > 16 || list.length < 2) return el.clientWidth * .8;
    return Math.max(60, list[1].offsetLeft - list[0].offsetLeft);
  }
  function build(el){
    if (el._isxPager) return;
    var p = document.createElement('div');
    p.className = 'isx-pager'; p.hidden = true;
    p.innerHTML = '<button type="button" aria-label="Previous">' + ARROW(-1) + '</button><span class="isx-pager__track" aria-hidden="true"><span class="isx-pager__thumb"></span></span><span class="isx-pager__n" aria-hidden="true"></span><button type="button" aria-label="Next">' + ARROW(1) + '</button>';
    el.parentNode.insertBefore(p, el.nextSibling);
    p._prev = p.children[0]; p._next = p.children[3]; p._thumb = p.querySelector('.isx-pager__thumb'); p._n = p.querySelector('.isx-pager__n');
    // smooth scroll, with a plain jump if the browser does not animate it (e.g. a page in the background)
    function go(d){
      var s0 = el.scrollLeft, dx = d * step(el);
      el.scrollBy({ left: dx, behavior: 'smooth' });
      setTimeout(function(){ if (Math.abs(el.scrollLeft - s0) < 2) { el.scrollLeft = s0 + dx; update(el); } }, 450);
    }
    p._prev.addEventListener('click', function(){ go(-1); });
    p._next.addEventListener('click', function(){ go(1); });
    el._isxPager = p;
    var queued = false;
    el.addEventListener('scroll', function(){ if (queued) return; queued = true; requestAnimationFrame(function(){ queued = false; update(el); }); }, { passive: true });
  }
  function all(){ document.querySelectorAll(SEL).forEach(function(el){ build(el); update(el); }); }
  function boot(){
    /* 2026-10-26 speed: measuring every carousel right away forced a whole-page layout mid-load (~85 ms on a
       slow phone). Build the (hidden) pagers now; measure each carousel when it comes near the screen. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting) { io.unobserve(e.target); update(e.target); } });
      }, { rootMargin: '400px 0px' });
      document.querySelectorAll(SEL).forEach(function(el){ build(el); io.observe(el); });
    } else { all(); window.addEventListener('load', all); }
    window.addEventListener('resize', function(){ clearTimeout(boot._t); boot._t = setTimeout(all, 150); });
    if (mq) { if (mq.addEventListener) mq.addEventListener('change', all); else if (mq.addListener) mq.addListener(all); }
    // filters (e.g. the 48-jar chips) change what a carousel holds
    document.addEventListener('click', function(){ setTimeout(all, 350); });
    document.addEventListener('shopify:section:load', all);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
